import React, {Component} from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import {NavLink , Link} from "react-router-dom";
import ContentAccordion from "../../components/ContentAccordion/ContentAccordion";
import {Helmet} from "react-helmet";
import store from "../../store";

class HowToShip extends Component {

    render() {

        return (
                <div className="wrapper">
                    <Helmet>
                        {
                            store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                                return row.rowTitle === "Learn" ? row.sections.map((section) => {
                                    return section.title === "How To Ship" ? <meta name="description" content={section.content['seo-description']}/> : null
                                }) : null
                            }) : null
                        }
                    </Helmet>
                    <Breadcrumbs/>
                    <h1 className="two-three-rows__title">How to Ship</h1>
                    <p className="two-three-rows__description">Shipping cargo can seem complex, but Southwest Cargo likes to keep
                        things simple. That's why we offer you effortless shipping with fast, efficient service. Follow these steps to
                        start shipping with us.</p>
                    <div className="how-to-ship__sections-container">
                        <div className="how-to-ship__section how-to-ship__section--vertical-align-center">
                            <div className="how-to-ship__section-left how-to-ship__section-left--light">
                                <h2 className="how-to-ship__section-title">Apply</h2>
                                <p className="how-to-ship__section-information">Become a Southwest Cargo Customer by filling out our
                                    application.</p>
                                <NavLink to="/ship/apply" className="cta-transparent how-to-ship__cta">Apply now</NavLink>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--light">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/apply.png" alt=""/>
                            </div>
                        </div>
                        <div
                                className="how-to-ship__section how-to-ship__section--greyed-out">
                            <div className="how-to-ship__section-left how-to-ship__section-left--greyed-out">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/get-approved.png" alt=""/>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--greyed-out">
                                <h2 className="how-to-ship__section-title">Get Approved</h2>
                                <p className="how-to-ship__section-information">Applications take 7-10 business days to process. Once your account
                                    is approved, you are ready to begin shipping with Southwest Cargo.</p>
                                <p className="how-to-ship__section-information">Once you’ve been approved for your Southwest Cargo Account, apply for an online booking account to book your NFG shipments up to 200 pounds up to ten days in advance.</p>
                            </div>
                        </div>
                        <div className="how-to-ship__section how-to-ship__section--vertical-align-center how-to-ship__section--apply">
                            <div className="how-to-ship__section-left how-to-ship__section-left--light">
                                <h2 className="how-to-ship__section-title">Choose your product </h2>
                                <p className="how-to-ship__section-information">Choose the speed you need, and let our award-winning Southwest Airlines Employees do the rest.</p>
                                <NavLink to="/ship/products" className="cta-transparent how-to-ship__cta">View products</NavLink>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--light">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/service-levels.png" alt=""/>
                            </div>
                        </div>
                        <div
                                className="how-to-ship__section how-to-ship__section--greyed-out">
                            <div className="how-to-ship__section-left how-to-ship__section-left--greyed-out">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/airwaybill.png" alt=""/>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--greyed-out">
                                <h2 className="how-to-ship__section-title how-to-ship__section-text--spaced">Fill out the universal air waybill</h2>
                                <p className="how-to-ship__section-information how-to-ship__section-text--spaced">Save time and let us know where your shipment needs to go by
                                    filling out a universal air waybill before getting to the facility. If shipping internationally, you
                                    will need to book your shipment in advance by contacting your
                                    <a href="./contact"> General Sales Agent.</a></p>
                                <a href="./pdf/Universal_airwaybills_Conditions_2.pdf" target="_blank" className="cta-transparent how-to-ship__cta">Universal Air Waybill</a>
                            </div>
                        </div>
                        <div className="how-to-ship__section how-to-ship__section--vertical-align-center">
                            <div className="how-to-ship__section-left how-to-ship__section-left--light">
                                <h2 className="how-to-ship__section-title">Bring your shipment to a local facility </h2>
                                <p className="how-to-ship__section-information">North, South, East, and yes, we go there. Choose from over 100
                                    shipping destinations.</p>
                                <NavLink to="/ship/facilities" className="cta-transparent how-to-ship__cta">Find a location</NavLink>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--light">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/your-shipment.png" alt=""/>
                            </div>
                        </div>
                        <div
                                className="how-to-ship__section how-to-ship__section--greyed-out">
                            <div className="how-to-ship__section-left how-to-ship__section-left--greyed-out">
                                <img className="how-to-ship__section-image" src="./assets/learn/how-to-ship/track-shipment.png" alt=""/>
                            </div>
                            <div className="how-to-ship__section-right how-to-ship__section-right--greyed-out">
                                <h2 className="how-to-ship__section-title">Track your shipment</h2>
                                <p className="how-to-ship__section-information">We know how important your cargo is, so we want to ensure you know
                                    where it is at all times. Sign up to receive real time notifications for the status of your air waybill <Link to="/manage/forms-and-applications/email-preference-form/" >here.</Link> </p>
                                <NavLink to="/manage/tracking" className="cta-transparent how-to-ship__cta">Track
                                    shipment</NavLink>
                            </div>
                        </div>
                        <div>
                            <p className="how-to-ship__section-information">Want to book your shipment in advance? Apply for an online booking account. <NavLink to="/ship/book"> Learn More</NavLink></p>
                        </div>
                    </div>
                    <div className="accordion">
                        <ContentAccordion
                                jsonDataUrl="./content/learn/page-components/accordion/how-to-ship.json"
                        />
                    </div>
                </div>
        )
    }
}

export default HowToShip;



// WEBPACK FOOTER //
// ./src/pages/learn/HowToShip.js